import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_ProofAndComplexity = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Proof of Correctness using Loop Invariant & Master's Theorem for Time Complexity"
      videos={[
        "https://www.youtube.com/embed/SElE4RlAji0",
        "https://www.youtube.com/embed/IZ7fyyAsOZc"
      ]}
      takeaways={[
        {
          text: "Loop invariants are used to prove correctness of iterative algorithms (e.g., insertion sort, selection sort)."
        },
        {
          text: "Master’s Theorem helps compute the time complexity of divide and conquer algorithms with recurrence relations like T(n) = aT(n/b) + f(n)."
        },
        {
          text: "Recursive Tree and Iteration methods are also effective for recurrence analysis."
        },
        {
          text: "Refer Abdul Bari’s YouTube videos for clear derivations of time complexities for common sorting algorithms."
        }
      ]}
      questions={[
        {
          text: "Write an iterative algorithm to compute the product of first ‘n’ natural numbers and prove its correctness using loop invariant."
        },
        {
          text: "Discuss the selection sort algorithm by providing its pseudo code. Discuss the loop invariant in perception with the selection sort algorithm. Check the proof of correctness for the same "
        },
        {
          text: "Consider the following pseudo code, Analyze its functionality and derive its time complexity. "
        },
        { image: "/TC1.png" },
        {
          text: "Using Master’s Theorem, solve the recurrence T(n) = 2T(n/2) + n³, n = 2^k."
        },
        {
          text: "Which one of the following is the recurrence equation for the worst-case time complexity of the Mergesort algorithm for sorting n (≥2) numbers? In the recurrence equations given in the options below, c is a constant. Justify your answer using appropriate argument ."
        },
        { image: "/TC2.png" },
        {
          text: "Derive the worst case time complexity of Merge Sort ."
        },
        {
          text: "Give the proof of correctness for the Quick Sort algorithm."
        },
        {
          text: "Show the proof of correctness of the following algorithm ."
        },
        { image: "/TC3.png" },
        {
          text: "Solve the following recurrence relations and find the time complexity for the following using Master's Theorem ."
        },
        { image: "/TC4.png" },
        {
          text: "Write a non-recursive algorithm to find the sum of the first 'n' odd numbers. Using the loop invariant property, prove the correctness of the algorithm ."
        },
        {
          text: "Demonstrate the iteration method to compute the asymptotic complexity for the following recurrence. "
        },
        { image: "/TC5.png" },
        {
          text: "Use the master's method to compute the asymptotic complexity for the following recurrences. In each case, identify the case of the master method that it uses to compute the asymptotic complexity. "
        },
        { image: "/TC6.png" },
        {
          text: "Using the master's theorem, solve the recurrence relation "
        },
        { image: "/TC7.png" },
        {
          text: "Solve the recurrence equation "
        },
        { image: "/TC8.png" },
        {
          text: "Write an iterative algorithm to find the sum of the equation. Prove that your algorithm is correct. "
        },
        { image: "/TC9.png" },
        {
          text: "Apply Master’s Theorem to T(n) = 2T(n/4) + √n + 42. Illustrate evaluation step-by-step."
        },
        {
          text: "Use backward substitution to find time complexity of T(n) = 2T(n/2) + n log n."
        },
        {
          text: "Design an algorithm by finding the required design paradigm to find the highest and lowest marks scored by students in the exam by fulfilling the below parameters and derive the respective recurrence relation for the same. i. Base case 1(If the input is only one element) give solution i.e what is highest and lowest? ii. Base case 2(If the input is two elements) give solution. iii. If the input is more than two elements, divide the inputs into sub- problems and use the recursive function for solving the sub- problems and write the procedure for combining the sub- solutions. "
        },
        {
          text: "Demonstrate Recursive Tree method to find time complexity for T(n) = 2T(n/2) + cn with level-wise time computation."
        }
      ]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_ProofAndComplexity;
